import { STORAGE_KEYS } from "../constants";
import { clearAllCredentialSecrets } from "./credentialStore";

export const resetSandboxState = () => {
  Object.entries(STORAGE_KEYS).forEach(([key, value]) => {
    if (key === "tourDismissed") return;
    globalThis.localStorage.removeItem(value);
  });
  clearAllCredentialSecrets();
};
